
export const environment = {
    production: true,
    apiUrl: 'https://proddeutschinstitutback.azurewebsites.net/DeutschInstitut/',
    nativeApiUrl: 'https://proddeutschinstitutback.azurewebsites.net/',
};
